export default {
      id: "crown-usage",
      viewBox: "0 -61 512 512",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#crown",
      toString: function () {
        return this.url;
      }
    }